import React from "react";
import {
  BrowserRouter,
  Switch,
  isAuthenticate,
  Login,
  Dashboard,
  Charge,
  CreateCharge,
  Limit,
  CreateLimit,
  ForgotPassword,
  CreateLevelWiseAccount,
  LevelWiseAccount,
  CashBackList,
  CreateCashBachREwards,
  RewardList,
  CreateReward,
  RouteWithLayout,
  PrivateRouteWithLayout,
  Main,
} from "../common";
import LevelCreate from "../screens/dashboard/level/LevelCreate";
import LevelList from "../screens/dashboard/level/LevelList";
import PerTransactionLimit from "../screens/dashboard/perTransactionLimit/PerTransactionLimit";
import CreatePerTransactionLimit from "../screens/dashboard/perTransactionLimit/CreatePerTransactionLimit";

const AppRoutes = () => (
  <BrowserRouter forceRefresh={true}>
    <Switch>
      {!isAuthenticate() && (
        <RouteWithLayout layout={Main} exact path="/" component={Login} />
      )}
      <RouteWithLayout layout={Main} path="/" component={Login} exact />
      <RouteWithLayout
        layout={Main}
        path="/forgot-password"
        component={ForgotPassword}
        exact
      />

      <PrivateRouteWithLayout path="/dashboard" component={Dashboard} exact />
      <PrivateRouteWithLayout path="/level" component={LevelList} exact />
      <PrivateRouteWithLayout path="/level-create" component={LevelCreate} exact />
      <PrivateRouteWithLayout
        path="/Commission/view-all"
        component={Charge}
        exact
      />
      


      {/* Overall Limit */}
      <PrivateRouteWithLayout path="/limit/view-all" component={Limit} exact />
      <PrivateRouteWithLayout
        path="/limit/create"
        component={CreateLimit}
        exact
      />


      {/* Per Transaction Limit */}
      <PrivateRouteWithLayout path="/per-transaction-limit/view-all" component={PerTransactionLimit} exact />
      <PrivateRouteWithLayout path="/per-transaction-limit/create" component={CreatePerTransactionLimit} exact />
      

      <PrivateRouteWithLayout
        path="/Commission/create"
        component={CreateCharge}
        exact
      />

      <PrivateRouteWithLayout
        path="/account-setup/view-all"
        component={LevelWiseAccount}
        exact
      />
      <PrivateRouteWithLayout
        path="/sender-cashback/view-all"
        component={CashBackList}
        exact
      />

      <PrivateRouteWithLayout
        path="/receiver-reward/view-all"
        component={RewardList}
        exact
      />

      <PrivateRouteWithLayout
        path="/account-setup/create"
        component={CreateLevelWiseAccount}
        exact
      />

      <PrivateRouteWithLayout
        path="/sender-cashback/create"
        component={CreateCashBachREwards}
        exact
      />

      <PrivateRouteWithLayout
        path="/receiver-reward/create"
        component={CreateReward}
        exact
      />
    </Switch>
  </BrowserRouter>
);

export default AppRoutes;
